// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3lQPI","search":"Settings_search__2Dl6p","filter":"Settings_filter__3AApV"};